import { useEffect, useState } from "react";
import { server } from "../../server";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { roleList } from "../../utils";
import { Link } from "react-router-dom";

function UserDetails() {
  const generateUserId = () => {
    const prefix = "AHR";
    const randomNumber = Math.floor(1000000 + Math.random() * 9000000);
    return `${prefix}${randomNumber}`;
  };

  const [formData, setFormData] = useState({
    userId: generateUserId(),
    name: "",
    email: "",
    phone: "",
    role: [],
    password: "",
  });

  const [userDetails, setUserDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;
  const [isEditing, setIsEditing] = useState(false);
  const [editUserId, setEditUserId] = useState(null);

  const totalFields = Object.keys(formData).length;
  const filledFields = Object.values(formData).filter((val) =>
    typeof val === "string" ? val.trim() !== "" : val.length > 0
  ).length;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError((prev) => ({ ...prev, [name]: false }));
  };

  const handleRoleChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      role: selectedOptions.map((option) => option.value),
    }));
    setError((prev) => ({ ...prev, role: false }));
  };

  const resetForm = () => {
    setFormData({
      userId: generateUserId(),
      name: "",
      email: "",
      phone: "",
      role: [],
      password: "",
    });
    setIsEditing(false);
  };

  const handleEditClick = (user) => {
    setIsEditing(true);
    setEditUserId(user.userId);
    setFormData({
      userId: user.userId || generateUserId(),
      name: user.name || "",
      email: user.email || "",
      phone: user.phone || "",
      role: user.role || [],
      password: "",
    });

    const modalElement = document.getElementById("addUserModal");
    if (modalElement) {
      const modal = new window.bootstrap.Modal(modalElement);
      modal.show();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (
        (typeof formData[key] === "string" && !formData[key].trim()) ||
        (Array.isArray(formData[key]) && formData[key].length === 0)
      ) {
        newErrors[key] = true;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }

    setLoading(true);

    try {
      let response;

      if (isEditing && editUserId) {
        response = await axios.post(
          `${server}/updateUserDetails`,
          {
            userId: editUserId,
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            role: formData.role,
          },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          toast.success("User Updated", { position: "top-right" });
          setUserDetails((prev) =>
            prev.map((user) =>
              user.userId === editUserId ? { ...user, ...formData } : user
            )
          );
        } else {
          toast.error("Update Failed", { position: "top-right" });
        }
      } else {
        response = await axios.post(`${server}/add_user_mongodb`, formData, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        toast.success("User Added", { position: "top-right" });
        setUserDetails((prev) => [...prev, formData]);
        fetchUserDetails();
      }

      const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
      if (closeButton) closeButton.click();

      setFormData({
        userId: generateUserId(),
        name: "",
        email: "",
        phone: "",
        role: [],
        password: "",
      });
      setIsEditing(false);
      setEditUserId(null);
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  const fetchUserDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${server}/alldata_ofuser_mongodb`, {
        headers: { Authorization: `${localStorage.getItem("token")}` },
      });
      const responseData = response.data?.["body-json"]?.body?.users;
      if (Array.isArray(responseData)) {
        setUserDetails(responseData);
      } else {
        console.error("Unexpected API Response Format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  // Filter
  const filteredRecords = userDetails.filter((user) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(user || {}).some(
      (value) =>
        typeof value === "string" && value.toLowerCase().includes(searchLower)
    );
  });

  // Calculate pagination
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div
              id="addUserModal"
              class="modal fade gd-example-modal-lg"
              tabindex="-1"
              role="dialog"
              aria-labelledby="myLargeModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <form onSubmit={handleSubmit}>
                    <div class="modal-header d-flex justify-content-between">
                      <h5 class="modal-title fs-4" id="exampleModalToggleLabel">
                        Add User{" "}
                        <span className="ms-3 text-secondary">
                          ({String(filledFields).padStart(2, "0")}/
                          {String(totalFields).padStart(2, "0")})
                        </span>
                      </h5>
                      <div className="d-flex align-items-center">
                        <span class="badge bg-success-soft me-3 px-3">
                          Editable
                        </span>
                        <div class="form-check form-switch me-4">
                          <input
                            type="checkbox"
                            class="form-check-input m-0"
                            checked
                          />
                        </div>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                    </div>

                    <div class="modal-body">
                      <div className="row g-2 mb-2">
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control text-dark ${
                              error.name ? "border-danger" : ""
                            }`}
                            placeholder="Enter Full Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Email Address <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control text-dark ${
                              error.email ? "border-danger" : ""
                            }`}
                            placeholder="Enter Email Address"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Phone No <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control text-dark ${
                              error.phone ? "border-danger" : ""
                            }`}
                            placeholder="Enter Phone No"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Role <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={roleList.map((item) => ({
                              value: item,
                              label: item,
                            }))}
                            isMulti={true}
                            placeholder="Select Role"
                            value={roleList
                              .filter((item) => formData.role.includes(item))
                              .map((item) => ({ value: item, label: item }))}
                            onChange={handleRoleChange}
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Password <span className="text-danger">*</span>
                          </label>
                          <input
                            type="password"
                            className={`form-control text-dark ${
                              error.password ? "border-danger" : ""
                            }`}
                            placeholder="Enter Password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer d-flex justify-content-between py-2">
                      <div>
                        <button
                          type="button"
                          class="btn btn-secondary px-3 me-1 rounded-pill"
                          data-bs-dismiss="modal"
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                        <button
                          type="submit"
                          class="btn btn-primary px-5 rounded-pill fw-normal"
                          disabled={loading}
                        >
                          {loading ? (
                            <div
                              class="spinner-border spinner-border-sm"
                              role="status"
                            ></div>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="container-fluid my-3 px-3">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                    <table class="table mb-0 text-nowrap table-centered">
                      <thead class="table-light">
                        <tr>
                          <th className="w-10">No.</th>
                          <th className="lh-1 w-60">
                            Details
                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Displaying Information as per Record
                            </span>
                          </th>
                          <th className="lh-1 w-30">
                            Action
                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Role-Specific Action Panel
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((userInfo, index) => (
                          <tr key={index}>
                            <td>{indexOfFirstRecord + index + 1}.</td>
                            <td className="lh-sm py-4 text-wrap">
                              <span class="text-dark">User ID</span> &mdash;{" "}
                              {userInfo.userId}
                              <br />
                              <span class="text-dark">Name</span> &mdash;{" "}
                              <span className="text-capitalize">
                                {userInfo.name}
                              </span>
                              <br />
                              <span class="text-dark">
                                Email ID
                              </span> &mdash; {userInfo.email}
                              <br />
                              <span class="text-dark">Role</span> &mdash;{" "}
                              {userInfo.role.map((role, index) => (
                                <span key={index}>
                                  {role}
                                  {index < userInfo.role.length - 1 && <br />}
                                </span>
                              ))}
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1 width-fit-content">
                                <span
                                  onClick={() => handleEditClick(userInfo)}
                                  class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                >
                                  Update
                                </span>
                                <span class="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                  Delete
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div class="">
                    <div className="mb-3">
                      <div className="d-flex bg-white justify-content-between rounded-4">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                        <Link
                          data-bs-toggle="modal"
                          onClick={resetForm}
                          data-bs-target="#addUserModal"
                          class="btn btn-warning px-5 fs-6 fw-medium rounded-4 fit-content"
                        >
                          Add User
                        </Link>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb pe-3">
                            <li class="breadcrumb-item">
                              <a href="#">Manage Administrator</a>
                            </li>
                            <li
                              class="breadcrumb-item active"
                              aria-current="page"
                            >
                              User Details
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div className="p-4 bg-white rounded-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {loading ? (
                            <div
                              className="spinner-border text-dark data-loader-spinner"
                              role="status"
                            ></div>
                          ) : (
                            <img src="/assets/images/folder.svg" />
                          )}

                          <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                            User Details
                            <br />
                            <span className="text-secondary fs-6 fw-medium lh-sm">
                              0.6 MB Size
                            </span>
                          </p>
                        </div>
                        <span className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer">
                          Export
                        </span>
                      </div>

                      <div class="px-4 py-2 mt-3 bg-light rounded-4">
                        <li className="list-group-item px-0">
                          <a
                            className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                            data-bs-toggle="collapse"
                            href="#specifications"
                            role="button"
                            aria-expanded="false"
                            aria-controls="specifications"
                          >
                            <p className="m-0 fw-medium lh-sm text-dark">
                              Download Report
                            </p>
                            <span className="chevron-arrow ms-4">
                              <i className="bi bi-chevron-down fs-4" />
                            </span>
                          </a>
                          <div
                            className="collapse"
                            id="specifications"
                            data-bs-parent="#ecommerceAccordion"
                          >
                            <div className="py-3">
                              <div class="rounded-4 d-flex flex-wrap">
                                <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                  User Details Report
                                </span>
                                <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                  Multi Role User Report
                                </span>
                                <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                  Fees Collection Role Report
                                </span>
                                <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                  User Details (PDF) Report
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>

                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);

                            if (currentPage > 3) {
                              pageNumbers.push("left-ellipsis");
                            }

                            if (
                              currentPage !== 1 &&
                              currentPage !== totalPages
                            ) {
                              pageNumbers.push(currentPage);
                            }

                            if (currentPage < totalPages - 2) {
                              pageNumbers.push("right-ellipsis");
                            }

                            if (totalPages > 1) {
                              pageNumbers.push(totalPages);
                            }

                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default UserDetails;
